import React, { useState, useEffect, useRef } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Modal } from 'bootstrap';
import { useNavigate, useLocation } from "react-router-dom";
import clientHttp from '../../components/ClientHttp';
import { formatDate } from '../../components/DateUtil';
import MagicEOMDetailList from './MagicEOMDetailList'
import Pagination from '../../components/Pagination';
import queryString from 'query-string';

import * as XLSX from 'xlsx/xlsx.mjs';

export default function MagicEOMReconcileContent() {
    const currentDate = new Date();
    const [fromDate, setFromDate] = useState(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()));
    const [toDate, setToDate] = useState(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate())); //useState(currentDate);
    const [filter, setFilter] = useState('A')
    const [filterValue, setFilterValue] = useState('')
    const [transType, setTransType] = useState('A')
    const [data, setData] = useState(null);
    const [error, setError] = useState('');
    const [errorClass, setErrorClass] = useState('');
    const [isSearchLoading, setIsSearchLoading] = useState(false)
    const [isLoadingExport, setIsLoadingExport] = useState(false)

    let navigate = useNavigate()

    let datePast = parseInt(process.env.REACT_APP_ORDERPAYMENT_DATEPAST)
    console.log('datePast: ' + datePast)

    // change page
    // change page
    const [currentPage, setCurrentPage] = useState(1);
    const [total, setTotal] = useState(0)
    const [pageSize, setPageSize] = useState(10);
    const onPageChange = (page) => {
        setCurrentPage(page);
        console.log('select page: ' + page)
        searchSubmit(page)
    }
    const selectPageSize = (e) => { setPageSize(e.target.value) }
    const changeFilterValue = (e) => { setFilterValue(e.target.value) }
    const onDateChange = (newDate) => {
        console.log('select from date: ' + newDate)
        setFromDate(newDate)
        setToDate(newDate)
        //setToDate(new Date(newDate.getFullYear(), newDate.getMonth(), newDate.getDate()+1))
    };

    // DatePicker
    const fromDateCalendar = useRef(null)
    const toDateCalendar = useRef(null)
    async function openFromDateCalendar() { fromDateCalendar.current.setFocus(true); }
    async function openToDateCalendar() { toDateCalendar.current.setFocus(true); }

    // dropdown list
    const selectFilter = (e) => { setFilter(e.target.value) }
    const selectTransType = (e) => { setTransType(e.target.value) }

    async function searchSubmit(page) {
        setCurrentPage(page);
        setIsSearchLoading(true)
        let isSuccess = false
        // clear data
        setError('')
        setErrorClass('')
        setData(null)

        console.log('call search api with parameters:' + fromDate, toDate, filter, filterValue, transType, page, pageSize)
        const _fromDate = fromDate.getFullYear() + '-' + (fromDate.getMonth() + 1) + '-' + fromDate.getDate();
        const toDate2 = new Date(toDate)
        toDate2.setDate(toDate2.getDate()+1)
        const _toDate = toDate2.getFullYear() + '-' + (toDate2.getMonth() + 1) + '-' + toDate2.getDate();
        const formData = {
            fromDate: _fromDate,
            toDate: _toDate,
            filter: filter,
            filterValue: filterValue,
            transType: transType,
            page: page,
            pageSize: pageSize,
        }
        console.log(formData)
        let token = localStorage.getItem('token')
        await clientHttp.post('report/v1/magiceomdetail', formData, {
            headers: { 'Authorization': 'Bearer ' + token }
        })
            .then(response => {
                console.log('response status: ' + response.status)
                if (response.data.status === 'success') {
                    console.log('display magic eom list')
                    setTotal(response.data.total)
                    setData(response.data.data)
                    //console.log(response)
                    isSuccess = true
                    setErrorClass('text-black')
                } else {
                    console.log('get magic eom list failed: ' + response.data.message)
                    setError(response.data.message)
                    setErrorClass('text-danger')
                }

            }).catch(err => {
                console.log('error: ', err.message)
                if (err.response.status === 401 || err.response.status === 403) {
                    console.log('no authorize, redirect to login page')
                    navigate(process.env.REACT_APP_LOGIN_URI)
                } else {
                    console.log('get magic eom list failed: ' + err.message)
                    setError(err.message)
                    setErrorClass('text-danger')
                }
            })

        if (!isSuccess) {
            let errorMessageModal = new Modal('#errorMessageModal')
            errorMessageModal.show()
        }
        setIsSearchLoading(false)
    }

    async function exportExcel() {
        console.log('call export excel api with parameters')
        setIsLoadingExport(true)
        let isSuccess = false

        // set token to header
        console.log('call search api with parameters:' + fromDate, toDate, filter, filterValue, transType)
        const _fromDate = fromDate.getFullYear() + '-' + (fromDate.getMonth() + 1) + '-' + fromDate.getDate();
        const toDate2 = new Date(toDate)
        toDate2.setDate(toDate2.getDate()+1)
        const _toDate = toDate2.getFullYear() + '-' + (toDate2.getMonth() + 1) + '-' + toDate2.getDate();
        const formData = {
            fromDate: _fromDate,
            toDate: _toDate,
            filter: filter,
            filterValue: filterValue,
            transType: transType,
            page: 0,
            pageSize: 0,
        }
        let token = localStorage.getItem('token')
        await clientHttp.post('report/v1/magiceomdetail', formData, {
            headers: { 'Authorization': 'Bearer ' + token }
        })
            .then(response => {
                console.log('response status: ' + response.status)
                if (response.data.status === 'success') {
                    console.log('export Magic EOM')
                    const curdate = new Date()
                    const exportFilename = 'MagicEOM_' + curdate.getFullYear() + '_' + curdate.getMonth() + '_' + curdate.getDate() + '.xlsx'
                    // convert date timezone
                    let excelData = response.data.data
                    for (let row of excelData) {
                        row.orderdate = formatDate(new Date(row.orderdate))
                    }
                    const worksheet = XLSX.utils.json_to_sheet(excelData);
                    const workbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(workbook, worksheet, "Magic_EOM");
                    XLSX.writeFile(workbook, exportFilename);
                    isSuccess = true
                } else {
                    console.log('get Magic EOM failed: ' + response.data.message)
                    setError(response.data.message)
                }

            }).catch(err => {
                console.log('error: ', err.message)
                if (err.response.status === 401 || err.response.status === 403) {
                    console.log('no authorize, redirect to login page')
                    navigate(process.env.REACT_APP_LOGIN_URI)
                } else {
                    console.log('get Magic EOM failed: ' + err.message)
                    setError(err.message)
                }
            })

        if (!isSuccess) {
            let errorMessageModal = new Modal('#errorMessageModal')
            errorMessageModal.show()
        }
        setIsLoadingExport(false)
    }

    const { search } = useLocation()
    const [passParameters, setPassParameters] = useState()

    useEffect(() => {
        // first enter then call search with current month
        //searchSubmit()

        // set default search values
        if (search) {
            const parsed = queryString.parse(search);
            console.log(parsed);
            if (parsed) {
                if (parsed.orderdate) {
                    let ary = parsed.orderdate.split("-")
                    setFromDate(new Date(ary[0], ary[1], ary[2]))
                    setToDate(new Date(ary[0], ary[1], ary[2]))
                }
                if (parsed.type) {
                    setTransType(parsed.type)
                }
                setPassParameters(true)
            }
        }
    }, [])

    useEffect(() => {
        if (passParameters) searchSubmit(1)

    }, [passParameters])

    return (
        <>
            <div className="page-header">
            </div>
            <div className="row">
                <div className="col-md-12">
                    {/* start form */}
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <div className="form-group">
                                        <div className="input-group ">
                                            <span className="input-group-text">From Date:</span>
                                            <DatePicker className="form-control" ref={fromDateCalendar} selected={fromDate} onChange={onDateChange} dateFormat="dd/MM/yyyy" />
                                            <span className="input-group-text" onClick={openFromDateCalendar.bind(this)}><i className="bi bi-calendar-date"></i></span>

                                            <span className="input-group-text ms-3">To Date:</span>
                                            <DatePicker className="form-control" ref={toDateCalendar} selected={toDate} onChange={(date) => setToDate(date)} dateFormat="dd/MM/yyyy" />
                                            <span className="input-group-text" onClick={openToDateCalendar.bind(this)}><i className="bi bi-calendar-date"></i></span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-1 col-md-1 col-sm-1">
                                    <div className="form-group">
                                        <div className="input-group">
                                            <select className="form-select" defaultValue={pageSize} onChange={selectPageSize}>
                                                <option value="5">5</option>
                                                <option value="10">10</option>
                                                <option value="20">20</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                                <option value="500">500</option>
                                                <option value="1000">1000</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-5 col-md-5 col-sm-5 col-xs-12">
                                    <div className="form-group">
                                        {isSearchLoading ?
                                            <button className="btn btn-black btn-border btn-primary" style={{ "width": "120px" }} type="button">
                                                <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                                <span role="status" className="ms-3">Loading...</span>
                                            </button>
                                            :
                                            <button type="button" className="btn btn-primary" style={{ "width": "120px" }} onClick={searchSubmit.bind(this, 1)}>
                                                <i className="bi bi-search me-2"></i> Search
                                            </button>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                    <div className="form-group">
                                        <div className="input-group ">
                                            <span className="input-group-text">Filter:</span>
                                            <select className="form-select" value={filter} onChange={selectFilter}>
                                                <option value="A">All</option>
                                                <option value="ABO">ABO No.</option>
                                                <option value="ORDER">Order No.</option>
                                            </select>
                                            <input type="text" className="form-control" placeholder="Enter value" onChange={changeFilterValue} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12">
                                    <div className="form-group">
                                        <div className="input-group ">
                                            <span className="input-group-text">Type:</span>
                                            <select className="form-select" value={transType} onChange={selectTransType}>
                                                <option value="A">All</option>
                                                <option value="S">No order generated</option>
                                                <option value="O">More than 1 order generated</option>
                                                <option value="M">Normal</option>
                                                <option value="N">Abnormal</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-2 col-sm-2">
                                    <div className="form-group">
                                        <div className="input-group">
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-5 col-md-5 col-sm-5 col-xs-12">
                                    <div className="form-group">
                                        {isLoadingExport ?
                                            <button className="btn btn-black btn-border" style={{ "width": "150px" }} type="button">
                                                <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                                <span role="status" className="ms-3">Loading...</span>
                                            </button>
                                            :
                                            <button type="button" className="btn btn-black btn-border" style={{ "width": "150px" }} onClick={exportExcel.bind(this)}>
                                                Export to Excel <i className="bi bi-download ms-2"></i>
                                            </button>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* end form */}
                </div>
            </div>

            <div className="row">
                <div className="col-md-12">
                    <MagicEOMDetailList data={data} />
                </div>
            </div>

            { data &&
            <Pagination total={total} pageSize={pageSize} currentPage={currentPage} onPageChange={onPageChange} />
            }
            <div className='row'>
                <div className='col-md-12'>
                    <div className="modal fade" id="errorMessageModal" tabIndex="-1" >
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-body">
                                    <p className={errorClass}>{error}</p>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}